import "antd/lib/form/style";
import _Form from "antd/lib/form";
import "antd/lib/card/style";
import _Card from "antd/lib/card";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/date-picker/style";
import _DatePicker from "antd/lib/date-picker";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@运维-设备信息*/
import React from 'react';
import { connect } from 'dva';
import BossLineChart from "../../Common/Charts/Line/BossLineChart";
import moment from 'moment';
import { parse } from '../../../utils/commonUtilFunc';
import { withRouter } from 'react-router-dom';
import { injectIntl } from "react-intl";
var Option = _Select.Option;
var RangePicker = _DatePicker.RangePicker;
var TunnelInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(TunnelInfo, _React$Component);
  function TunnelInfo(props) {
    var _this;
    _classCallCheck(this, TunnelInfo);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TunnelInfo).call(this, props)); //在有多条隧道情况下切换隧道
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelectTunnelType", function (e) {
      var offId = sessionStorage.getItem("tunnelOffId");
      clearInterval(offId);
      var tunnelList = _this.props.mi0102Info.tunnelList;
      var bandwidth = 0;
      for (var key in tunnelList) {
        if (tunnelList[key].value === e.target.value) {
          bandwidth = tunnelList[key].bandwidth;
        }
      }
      _this.props.dispatch({
        type: "mi0102Info/changeTunnel",
        payload: {
          tunnel: e.target.value,
          bandwidth: bandwidth
        }
      }).then(function () {
        _this.get_tunnel_data();
      });
    }); //获取隧道信息的各类数据
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_tunnel_data", function () {
      var linkInfo = _this.state.linkInfo;
      _this.props.dispatch({
        type: "mi0102Info/get_tunnel_data",
        payload: {
          tunnel_id: linkInfo.id || linkInfo.link_id,
          companyid: linkInfo.company_id,
          start_tm: _this.state.start_tm,
          end_tm: _this.state.end_tm,
          tid: linkInfo.id || linkInfo.link_id,
          sn: linkInfo.device_sn || linkInfo.sn,
          from: 'link',
          showlinedata: _this.state.linkInfo && _this.state.linkInfo.bandwidth ? _this.state.linkInfo.bandwidth * 0.9 : ''
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectTimeInterval", function (value) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      var start_tm = "";
      var end_tm = moment().format("YYYY-MM-DD HH:mm:ss");
      var time = parse(_this.props.location.search).time;
      switch (value) {
        case "0":
          start_tm = moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "1":
          start_tm = moment().subtract(6, 'hours').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "2":
          start_tm = moment().subtract(24, 'hours').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "3":
          start_tm = moment().subtract(7, 'days').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "4":
          start_tm = moment(time).subtract(15, 'minutes').format("YYYY-MM-DD HH:mm:ss");
          end_tm = moment(time).add(15, 'minutes').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "5":
          start_tm = moment(time).subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss");
          end_tm = moment(time).add(30, 'minutes').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "6":
          start_tm = moment(time).subtract(3, 'hours').format("YYYY-MM-DD HH:mm:ss");
          end_tm = moment(time).add(3, 'hours').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "7":
          start_tm = moment(time).subtract(12, 'hours').format("YYYY-MM-DD HH:mm:ss");
          end_tm = moment(time).add(12, 'hours').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "8":
          start_tm = moment(time).subtract(1, 'days').format("YYYY-MM-DD HH:mm:ss");
          end_tm = moment(time).add(1, 'days').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "9":
          start_tm = moment(time).subtract(3, 'days').format("YYYY-MM-DD HH:mm:ss");
          end_tm = moment(time).add(3, 'days').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "10":
          start_tm = moment(time).subtract(1, 'month').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "11":
          start_tm = moment(time).subtract(1, 'year').format("YYYY-MM-DD HH:mm:ss");
          break;
        default:
          start_tm = moment().subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss");
          break;
      }
      _this.setState({
        start_tm: start_tm,
        end_tm: end_tm,
        intervalType: value
      }, function () {
        vm.get_tunnel_data();
      });
    }); //切换图表刷新间隔时间
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectRefreshInterval", function (value) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      var timeInterval;
      clearInterval(_this.state.offId);
      _this.props.mi0102Info.refreshType = value;
      switch (value) {
        case "0":
          return;
        case "1":
          timeInterval = 15 * 1000;
          break;
        case "2":
          timeInterval = 30 * 1000;
          break;
        case "3":
          timeInterval = 60 * 1000;
          break;
        default:
          return;
      }
      var offId = setInterval(function () {
        vm.selectTimeInterval(vm.state.intervalType);
      }, timeInterval);
      _this.setState({
        offId: offId
      });
      sessionStorage.setItem("tunnelOffId", offId);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disabledDate", function (current) {
      return current.diff(_this.state.start_tm, 'days') < -5 || current.diff(_this.state.start_tm, 'days') > 6;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRangeChange", function (moment) {
      if (moment.length === 1) {
        _this.setState({
          start_tm: moment[0].format("YYYY-MM-DD HH:mm:ss")
        });
      } else if (moment.length === 2) {
        _this.setState({
          start_tm: moment[0].format("YYYY-MM-DD HH:mm:ss"),
          end_tm: moment[1].format("YYYY-MM-DD HH:mm:ss")
        }, function () {
          _this.get_tunnel_data();
        });
      }
    });
    _this.state = {
      end_tm: moment().format("YYYY-MM-DD HH:mm:ss"),
      start_tm: moment().subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss"),
      intervalType: "0",
      linkInfo: _this.props.linkInfo
    };
    return _this;
  }
  _createClass(TunnelInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.get_tunnel_data();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;
      if (JSON.stringify(nextProps.linkInfo) !== JSON.stringify(this.props.linkInfo)) {
        this.setState({
          linkInfo: nextProps.linkInfo
        }, function () {
          _this2.get_tunnel_data();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var inEnglish = window.appLocale.locale === "en-US";
      var chartPropsI = {
        id: "tunnelSpeed",
        containerHeight: 400,
        option: {
          xAxis: {
            type: 'time',
            boundaryGap: true,
            name: "time",
            min: this.state.start_tm,
            max: this.state.end_tm
          },
          yAxis: {
            type: 'value',
            name: "Rate (Mbps)"
          },
          series: this.props.mi0102Info.tunnelInfoSeries.speed
        }
      };
      var chartPropsII = {
        id: "RTT",
        containerHeight: 400,
        option: {
          xAxis: {
            type: 'time',
            boundaryGap: false,
            name: "time",
            min: this.state.start_tm,
            max: this.state.end_tm
          },
          yAxis: [{
            type: 'value',
            name: "Network latency (ms)",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }, sessionStorage.getItem("role") === 'company' || sessionStorage.getItem('role') === 'companystaff' ? {
            type: 'value',
            name: "",
            boundaryGap: false,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          } : {
            type: 'value',
            name: "Get(ms)",
            boundaryGap: false,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }],
          series: this.props.mi0102Info.tunnelInfoSeries.rttGet
        }
      };
      var chartPropsIII = {
        id: "sessionCount",
        containerHeight: 400,
        option: {
          xAxis: {
            type: 'time',
            boundaryGap: false,
            min: this.state.start_tm,
            max: this.state.end_tm,
            axisTick: {
              show: false
            }
          },
          yAxis: {
            type: 'value',
            name: "Number of sessions",
            minInterval: 1
          },
          series: this.props.mi0102Info.tunnelInfoSeries.session
        }
      }; // const chartPropsIV = {
      //     id: "tunnelStatus",
      //     containerHeight: 400,
      //     option: {
      //         xAxis: {
      //             type: 'time',
      //             boundaryGap: false,
      //             min: this.state.start_tm,
      //             max: this.state.end_tm,
      //             axisTick: {show: false},
      //         },
      //         yAxis: {type: 'category', data: ["OFFLINE", "ONLINE", ""], boundaryGap: false,axisLine:{show:true,lineStyle:{color:"rgba(0,0,0,0.45)"}}},
      //         series: this.props.mi0102Info.tunnelInfoSeries.tunnelStatus
      //     }
      // };
      var option = [/*#__PURE__*/React.createElement(Option, {
        value: "0",
        key: "0"
      }, "Last 30 minutes"), /*#__PURE__*/React.createElement(Option, {
        value: "1",
        key: "1"
      }, "Last 6 hours"), /*#__PURE__*/React.createElement(Option, {
        value: "2",
        key: "2"
      }, "Last Day"), /*#__PURE__*/React.createElement(Option, {
        value: "3",
        key: "3"
      }, "Last week"), /*#__PURE__*/React.createElement(Option, {
        value: "10",
        key: "10"
      }, "Last month"), /*#__PURE__*/React.createElement(Option, {
        value: "11",
        key: "11"
      }, "Last year")];
      var dateFormat = 'YYYY-MM-DD HH:mm:ss';
      return /*#__PURE__*/React.createElement(_Card, {
        className: "card"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("header", {
        style: {
          marginBottom: 16
        }
      }, /*#__PURE__*/React.createElement(_Select, {
        style: {
          width: inEnglish ? 250 : 150,
          marginRight: 8
        },
        placeholder: "Please select a time interval",
        onChange: this.selectTimeInterval,
        defaultValue: "0"
      }, option), /*#__PURE__*/React.createElement(RangePicker, {
        style: {
          width: 350,
          marginRight: 8
        },
        showTime: true,
        value: [moment(this.state.start_tm, dateFormat), moment(this.state.end_tm, dateFormat)] // disabledDate={this.disabledDate} 
        ,
        onCalendarChange: this.handleRangeChange
      }), /*#__PURE__*/React.createElement(_Select, {
        onChange: this.selectRefreshInterval,
        style: {
          width: 150,
          marginRight: 8
        },
        defaultValue: "0"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "0",
        key: "0"
      }, "Do not refresh"), /*#__PURE__*/React.createElement(Option, {
        value: "1",
        key: "1"
      }, "15 second refresh"), /*#__PURE__*/React.createElement(Option, {
        value: "2",
        key: "2"
      }, "30 second refresh"), /*#__PURE__*/React.createElement(Option, {
        value: "3",
        key: "3"
      }, "60 second refresh"))), /*#__PURE__*/React.createElement(_Card, {
        style: {
          marginBottom: 16
        },
        className: "card"
      }, /*#__PURE__*/React.createElement(BossLineChart, Object.assign({}, chartPropsI, {
        ifNotMerge: true
      }))), /*#__PURE__*/React.createElement(_Card, {
        style: {
          marginBottom: 16
        },
        className: "card"
      }, /*#__PURE__*/React.createElement(BossLineChart, Object.assign({}, chartPropsII, {
        ifNotMerge: true
      }))), /*#__PURE__*/React.createElement(_Card, {
        style: {
          marginBottom: 16
        },
        className: "card"
      }, /*#__PURE__*/React.createElement(BossLineChart, Object.assign({}, chartPropsIII, {
        ifNotMerge: true
      })))));
    }
  }]);
  return TunnelInfo;
}(React.Component);
function mapDispatchToProps(_ref) {
  var mi0102Info = _ref.mi0102Info;
  return {
    mi0102Info: mi0102Info
  };
}
export default connect(mapDispatchToProps)(_Form.create()(withRouter(injectIntl(TunnelInfo))));